/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TestConnectionRequest } from '../models/TestConnectionRequest';
import type { UUID } from '../models/UUID';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TestConnectionResourceService {

    /**
     * Get the number of tables in a provided data source
     * @param id
     * @param requestBody Data Source configuration to retry to connect to
     * @returns any Number of tables in a provided data source
     * @throws ApiError
     */
    public static retestConnection(
        id: UUID,
        requestBody: TestConnectionRequest,
    ): CancelablePromise<{
        numberOfTables: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/data-sources/retest-connection/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get the number of tables in a provided data source
     * @param requestBody Data Source configuration to try to connect to
     * @returns any Number of tables in a provided data source
     * @throws ApiError
     */
    public static testConnection(
        requestBody: TestConnectionRequest,
    ): CancelablePromise<{
        numberOfTables: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/data-sources/test-connection',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
